<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Applicability question update review</h4>
    <div class="title-actions">
      <button
        mat-button
        [mat-dialog-close]=""
        (click)="onClose()"
        cdkFocusInitial
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div mat-dialog-content class="update-review dialog-content">
    <h4 class="sectionTitle">{{ data.rbName }}</h4>
    <div class="para">
      <div>Question: <span [innerHTML]="newQuestion"></span></div>
    </div>
    @if (data.content.answerDropped) {
    <div class="answer-dropped-note">
      @if (isNewQuestion) {
      This is a new applicability question. Please review and answer it.
      } @else {
      Your previous answer to this question was cleared because it changed
      significantly. Please review and answer it again.
      }
    </div>
    }
  </div>
  <div mat-dialog-actions>
    <div>
      <button
        mat-button
        (click)="onRemoveFlag()"
        class="button-close"
        cdkFocusInitial
      >
        Got it
      </button>
      <button
        mat-button
        (click)="onClose()"
        mat-dialog-close
        class="button-close"
      >
        Close
      </button>
    </div>
  </div>
</div>
